import React from "react";
import { useSelector } from "react-redux";
import { useCollection } from "react-firebase-hooks/firestore";
import { collection, query, where, orderBy, limit } from "firebase/firestore";
import { Firestore } from "../firebase/firebase";
import { hasRole } from "../firebase";
import { Grid, Segment } from "semantic-ui-react";
import List from "./list";
import Loading from "../app/loading";
import NotFound from "../app/404";
import { Waiting } from "../app/thankyou";
const Dashboard = () => {
  const user = useSelector((state) => state.user || null);

  const editor = `${user.displayName} (${user.organisation})`;

  const q = query(
    collection(Firestore, "banner-index"),
    where("lastModBy", "==", editor),
    orderBy("lastModAt", "desc"),
    limit(10)
  );

  const [value, loading, error] = useCollection(q, {
    snapshotListenOptions: { includeMetadataChanges: true },
  });

  if (user && !hasRole(user)) return <Waiting />;

  if (error) return <NotFound />;

  if (!user || loading) return <Loading />;

  if (value) {
    const banners = value.docs.map((doc) => {
      return { id: doc.id, ...doc.data() };
    });

    return (
      <>
        <Grid padded>
          <Grid.Column width={16}>
            <Segment attached="top">Last edited by you</Segment>
            {banners && <List banners={banners} start={0} pageBy={25} />}
          </Grid.Column>
        </Grid>
      </>
    );
  }
};

export default Dashboard;
